const en = {
  nav: {
    home: 'Home',
    products: 'Our Products',
    about: 'About',
    contact: 'Contact',
  },
  home: {
    hero: {
      eyebrow: 'Finisher Kits & Technical Textiles',
      title1: 'EQUIP YOUR',
      title2: 'SPORTS EVENTS',
      subtitle: 'Custom medals, textiles and accessories for sports event organizers in Belgium and France.',
      cta1: 'Discover our packs',
      cta2: 'Request a quote',
    },
    problems: {
      title: 'The organizer\'s challenge',
      pain_title: 'Recurring problems',
      solution_title: 'The Ultra Sport approach',
      pains: [
        'Delivery deadlines not met',
        'Disappointing quality on delivery',
        'Non-specialized sports contact',
        'No personalized follow-up',
        'Last-minute surprises',
        'Complex multi-supplier logistics',
      ],
      solutions: [
        'Guaranteed reverse planning',
        'Field-tested and validated products',
        'Sports event expert',
        'One contact from quote to delivery',
        'BAT validated before every production',
        'Delivery always included',
      ],
    },
    packs: {
      title: 'Our Complete Packs',
      subtitle: 'From essential to premium, a solution for every event',
      cta: 'See full details',
      see_all: 'See all products',
      essential: {
        name: 'Finisher Essential Pack',
        participants: '200 – 800 participants',
        tagline: 'Simple, effective, controlled budget',
        items: [
          'Trail cup',
          'Lifestyle or sports cap',
          'Running and Cycling socks',
          '500 ml flask',
          '... (all your projects are achievable)',
        ],
      },
      performance: {
        name: 'Performance Pack',
        participants: '800 – 1500+ participants',
        badge: 'RECOMMENDED',
        tagline: 'Ideal for Trail and Triathlon',
        loyalty: '2nd order -20%',
        items: [
          'Finisher medal 6cm and 2.5 cm sublimation ribbon',
          'Lifestyle and Sports cap',
          'Trail flask',
          'Backpack',
          '... All your projects are achievable',
        ],
      },
      premium: {
        name: 'Premium Pack',
        participants: '1500 – 2000+ participants',
        tagline: 'Strong image and lasting memory',
        loyalty: '2nd -20%, 3rd -30%',
        items: [
          'Trail cup',
          'Ice Silk Buff premium',
          'Embroidered cap',
          'Trail flask',
          'Backpack',
          '... All your projects are achievable',
        ],
      },
    },
    vip: {
      title: 'The VIP Experience for your Participants',
      formula: 'UltraTiming + Ultra Sport = VIP Distribution Setup',
      description: 'Combine UltraTiming\'s expert timing with Ultra Sport\'s premium kits to offer an unforgettable finisher experience.',
      timing_label: 'Expert timing & real-time results',
      goodies_label: 'Premium finisher kits & organized distribution',
      result_label: 'Complete VIP event',
      discover: 'Discover UltraTiming.live',
    },
    clients: {
      title: 'They Trust Us',
      subtitle: 'More than 18 sports events have entrusted us with their finisher kits',
    },
    promo: {
      badge: 'SPECIAL OFFER',
      text: 'Finisher Pack T-shirt + Medal from',
      price: '€6.50 excl. VAT',
      cta: 'Request a quote',
    },
    why_choose: {
      eyebrow: 'Why choose us?',
      title: '6 Reasons to choose Ultra Sport',
    },
    stats: {
      events: { value: 150, suffix: '+', label: 'Events equipped' },
      delivery: { value: 100, suffix: '%', label: 'On-time delivery' },
      participants: { value: 50000, suffix: '+', label: 'Satisfied participants' },
      expertise: { value: 2015, suffix: '', label: "Since" },
    },
    reasons: {
      planning: { title: 'Guaranteed Planning', desc: 'Delivery assured before your event, no surprises' },
      quality: { title: 'Tested Quality', desc: 'Products validated in the field by athletes' },
      expert: { title: 'Sports Expert', desc: 'Sports event specialist since 2015' },
      contact: { title: 'Single Point of Contact', desc: 'One contact from quote to delivery' },
      bat: { title: 'BAT Validated', desc: 'Proof approved before each production' },
      delivery: { title: 'Delivery Included', desc: 'Shipping always included, no hidden fees' },
    },
    contact: {
      title: 'Request a Quote',
      subtitle: 'Tell us about your event — guaranteed reply within 24h',
      nom: 'Last name',
      prenom: 'First name',
      email: 'Email',
      event_name: 'Event name',
      participants: 'Number of participants',
      pack_choice: 'Pack choice',
      event_date: 'Event date',
      message: 'Message',
      pack_options: ['Finisher Essential Pack', 'Performance Pack', 'Premium Pack', 'Special Offer T-shirt + Medal', 'Custom quote'],
      submit: 'Send request',
      sending: 'Sending...',
      success: 'Your request has been sent! We\'ll get back to you within 24h.',
      error: 'An error occurred. Please try again.',
    },
  },
  products: {
    title: 'Our Products',
    subtitle: 'Complete catalogue of finisher kits and technical textiles',
    packs_title: 'Our Complete Packs',
    packs_subtitle: 'Turnkey solutions for every event',
    catalog_title: 'Our Creations',
    catalog_subtitle: 'Discover our custom creations',
    planning_title: 'Reverse Planning',
    planning_subtitle: 'Calculate your deadlines — safe delivery guaranteed',
    quality_title: 'Quality Guaranteed',
    quality_badge: 'No product enters our catalogue without being internally tested and validated by the UltraTiming team',
    request_quote: 'Request a quote',
    products_included: 'Products included',
    services_included: 'Services included',
    ideal_for: 'Ideal for',
    na: 'N/A',
    filters: {
      all: 'All',
      textile: 'Textile',
      medals: 'Medals',
      hydration: 'Hydration',
      accessories: 'Accessories',
      bags: 'Bags',
      packaging: 'Packaging',
    },
    packs: {
      essential: {
        name: 'Finisher Essential Pack',
        badge: 'ESSENTIAL',
        participants: '200 – 800 participants',
        tagline: 'Simple, effective, controlled budget',
        services: [
          'Graphic design included (1 proposal + edits)',
          'Mandatory BAT before production',
          'Production launch after validation',
          'Delivery always included',
          'Guaranteed realistic deadline (reverse planning)',
        ],
        products: [
          'Trail cup',
          'Lifestyle or sports cap',
          'Running and Cycling socks',
          '500 ml flask',
          '... (all your projects are achievable)',
        ],
      },
      performance: {
        name: 'Performance Pack',
        badge: '★ RECOMMENDED ★',
        participants: '800 – 1500+ participants',
        tagline: 'Ideal for Trail and Triathlon',
        loyalty: '2nd order: -20%',
        services: [
          'Graphic design included (1 proposal + edits)',
          'Mandatory BAT validation',
          'Production launch',
          'Delivery included',
          '2nd goodies order: -20%',
        ],
        products: [
          'Finisher medal 6cm and 2.5 cm sublimation ribbon',
          'Lifestyle and Sports cap',
          'Trail flask',
          'Backpack',
          '... All your projects are achievable',
        ],
      },
      premium: {
        name: 'Premium Pack',
        badge: 'PREMIUM',
        participants: '1500 – 2000+ participants recommended',
        tagline: 'Strong image and lasting memory',
        loyalty: '2nd -20% | 3rd -30%',
        services: [
          'Graphic design included (2 proposals + edits)',
          'Mandatory BAT validation',
          'Production launch',
          'Delivery included',
          '2nd goodies order: -20%',
          '3rd goodies order: -30%',
        ],
        products: [
          'Trail cup',
          'Ice Silk Buff premium',
          'Embroidered cap',
          'Trail flask',
          'Backpack',
          '... All your projects are achievable',
        ],
      },
    },
    quality: {
      medals_title: 'Medals',
      medals_text: 'Robust zinc alloy, controlled finishes, relief/enameling/cutting, precise BAT validation',
      textile_title: 'Textile',
      textile_text: 'Resistant sublimation, breathable sports fabric, optimized unisex sizes, same producers as Compressport',
      accessories_title: 'Accessories',
      accessories_text: 'Food-grade certified materials, resistant, field-tested for trail/running/triathlon',
    },
    planning_note: '10 working days between signed quote and production launch. Format = production days + delivery days.',
    planning_products: {
      tshirt: 'Technical T-shirt',
      cup: 'Cup / Flask',
      buff: 'Buff / Neck gaiter',
      cap: 'Cap',
      socks: 'High socks',
      medal: 'Medal',
      backpack: 'Backpack',
      packaging: 'Premium packaging',
    },
    items: {
      tshirt_210: { name: 'Technical T-shirt 210gr', desc: '100% breathable polyester, 210gr/m², 1-color sublimation, unisex XS to 3XL', ideal: 'Budget events, large quantities', packs: 'Essential' },
      tshirt_110: { name: 'Technical T-shirt 110gr Textured', desc: 'Ultra-light textured polyester, full sublimation, mesh breathable fabric, XS to 3XL', ideal: 'Trail, triathlon, long-duration running', packs: 'Performance & Premium' },
      medal_6cm: { name: 'Finisher Medal 6cm', desc: 'Robust zinc alloy, engraved relief, 2cm custom sublimated ribbon, mandatory BAT', ideal: 'Events 800–1500+ participants', packs: 'Performance' },
      medal_7cm: { name: 'Finisher Medal 7cm Premium', desc: 'Zinc alloy, premium finishes, 3cm ribbon, enameling and special cutting possible', ideal: 'Prestige events 1500+ participants', packs: 'Premium' },
      medal_custom: { name: 'Custom Medal', desc: 'Free shape, custom dimensions, multiple finishes (gold, silver, bronze, enameled)', ideal: 'Events with strong identity', packs: 'On quote' },
      cup_silicon: { name: 'Foldable Silicon Cup', desc: 'Food-grade certified BPA-free silicone, 150ml or 200ml, 1–3 color logo, clip attachment', ideal: 'Trail, running, eco-friendly events', packs: 'All packs' },
      cup_pp: { name: 'Reusable PP Cup', desc: 'BPA-free polypropylene, 25cl or 33cl, 1–3 color logo, rigid and stackable', ideal: 'Bib distribution, economical', packs: 'All packs' },
      flask_150: { name: 'Soft Trail Flask 150ml', desc: 'Food-certified TPU, leak-proof bite valve cap, 1–3 color logo', ideal: 'Trail, running, compatible with hydration belt', packs: 'All packs' },
      flask_250: { name: 'Soft Trail Flask 250ml', desc: 'Food-certified TPU, bite valve cap, 1–3 color logo', ideal: 'Long-distance trail, triathlon', packs: 'All packs' },
      buff_poly: { name: 'Polyester Buff / Neck Gaiter', desc: '100% light polyester, full sublimation print, universal size, 12 ways to wear', ideal: 'All-season events', packs: 'Essential' },
      buff_icesilk: { name: 'Ice Silk Buff / Neck Gaiter', desc: 'Cool-touch material, cooling effect, HD full sublimation print', ideal: 'Summer, hot trail, triathlon', packs: 'Performance & Premium' },
      cap_5p_1c: { name: '5-Panel Cap — 1 Color', desc: 'Breathable polyester/cotton, curved visor, velcro or snapback, 1-color silkscreen', ideal: 'Budget events', packs: 'Essential' },
      cap_56p_2c: { name: '5/6-Panel Cap — 2 Colors', desc: 'Breathable polyester, anti-UV possible, velcro/snapback/elastic, 2-color silkscreen', ideal: 'Trail, triathlon', packs: 'Performance' },
      cap_emb: { name: 'Embroidered Cap 2 Colors', desc: 'Premium polyester or combed cotton, high-quality 2-color embroidery, premium finish', ideal: 'Premium brand image', packs: 'Premium' },
      socks: { name: 'High Sports Socks', desc: 'Polyester/elastane, heel and toe reinforcements, 1–2 color jacquard logo, sizes 35–46', ideal: 'Trail, running, triathlon, long distance', packs: 'All packs' },
      backpack: { name: 'Lightweight Trail/Sports Backpack', desc: 'Light nylon 5–10L, 2-color logo, padded straps, hydration pack compatible', ideal: 'Long-distance trail, memorable gift', packs: 'Performance & Premium' },
      totebag: { name: 'Non-Woven Tote Bag', desc: 'Recyclable polypropylene 38x42cm, 1-color logo', ideal: 'Bib distribution, goodies bag', packs: 'On quote' },
      sachet_zip: { name: 'Custom Transparent Zip Bag', desc: 'Clear plastic with zip, logo + event name, sizes S/M/L', ideal: 'Premium presentation of each kit', packs: 'Premium' },
      box_premium: { name: 'Premium Cardboard Box', desc: 'Rigid cardboard, matte or glossy finish, custom full-print exterior, custom size', ideal: 'High-end participant experience', packs: 'Premium — on quote' },
    },
  },
  about: {
    title: 'About',
    subtitle: 'The finisher kit expert for sports events',
    story_title: 'Our Story',
    story_text: 'Ultra Sport was born from a passion for sports events and a frustration shared by many organizers: finding a reliable, specialized supplier who understands the unique constraints of the sports world. Founded by the UltraTiming team, we put our field expertise at the service of event organizers in Belgium and France. Every product in our catalogue has been tested and validated during real events before being offered.',
    values_title: 'Our Values',
    values: [
      { title: 'Reliability', text: 'Our commitments are kept. Deadlines, quality and communication: we make no compromises on what matters on event day.' },
      { title: 'Sports Expertise', text: 'We know sports events from the inside. Trail, triathlon, running: we\'ve lived this world for years.' },
      { title: 'Tested Quality', text: 'Every product is field-tested before entering our catalogue. Zero surprises on your event day.' },
      { title: 'Lasting Partnership', text: 'Long-term partner, loyalty rewarded. -20% from the 2nd order, -30% at the 3rd. We grow together.' },
    ],
    partnership_title: 'Our UltraTiming Partnership',
    partnership_text: 'Ultra Sport is the goodies and textiles branch of UltraTiming, European specialist in sports event timing. This unique synergy allows us to perfectly understand organizers\' needs and offer a complete event solution.',
    partnership_cta: 'Discover UltraTiming.live',
    clients_title: 'They Trust Us',
    clients_subtitle: 'Events of all sizes trust us for their finisher kits',
    cta_title: 'Ready to equip your event?',
    cta_text: 'Contact us for a personalized quote. Reply guaranteed within 24h.',
    cta_button: 'Request a quote',
  },
  footer: {
    tagline: 'The official equipment for your sports events',
    contact_email: 'info@ultrasport.live',
    ultratiming: 'Visit UltraTiming.live',
    copyright: '© 2026 Ultra Sport – Sports Event Goodies. All rights reserved.',
  },
};

export default en;
